import type { Activity as ApiActivity } from '@kizen/api/activities';

import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import ActivityForm from 'components/ActivityForm';
import BasicModal from '__components/Modals/presets/BasicModal';
import { activityQuery } from 'query/activities';
import { snakeToCamelCaseKeys } from '__services/helpers';

type Activity = SnakeToCamelCase<ApiActivity>;

type ActivityBuilderPreviewProps =
  | {
      activity: Activity;
      actionBtnColor: string;
      onHide(): void;
    }
  | {
      activityId: string;
      actionBtnColor: string;
      onHide(): void;
    };

type RequiresLoadingProps = Exclude<
  ActivityBuilderPreviewProps,
  { activity: Activity }
>;

const ActivityBuilderPreview = (props: ActivityBuilderPreviewProps) => {
  const { onHide, actionBtnColor } = props;

  const { t } = useTranslation();

  const shouldLoadActivity = 'activityId' in props;

  const query = useQuery(
    activityQuery((props as RequiresLoadingProps).activityId, {
      enabled: shouldLoadActivity,
      select: (data) => {
        return snakeToCamelCaseKeys(data);
      },
    })
  );

  const isLoading = shouldLoadActivity && query.isLoading;

  const activity = shouldLoadActivity ? query.data : props.activity;

  return (
    <BasicModal
      show
      size="medium"
      buttonText={t('Close')}
      heading={`${t('Previewing')} ${activity?.name}`}
      leftBtn={null}
      onConfirm={onHide}
      onHide={onHide}
      enforceFocus={false}
      actionBtnColor={actionBtnColor}
    >
      {!isLoading && <ActivityForm activity={activity} />}
    </BasicModal>
  );
};

export default ActivityBuilderPreview;
